/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Muddy_Goose_TrimInputs */

const fr_shy_muddy_goose_trim = /** @type {(inputs: Shy_Muddy_Goose_TrimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiert une confirmation`)
};

/**

* @param {Shy_Muddy_Goose_TrimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const shy_muddy_goose_trim = /** @type {((inputs?: Shy_Muddy_Goose_TrimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Muddy_Goose_TrimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_shy_muddy_goose_trim(inputs)
});